<template>
  <div class="resumo-calculo">
    <!-- Header -->
    <div class="resumo-calculo__header">
      <i class="bx bx-calculator"></i>
      <span>Resumo do Cálculo</span>
    </div>

    <!-- Grid 2 colunas -->
    <div class="resumo-calculo__body">
      <div class="resumo-calculo__grid">

        <!-- Coluna Esquerda -->
        <div class="resumo-calculo__col">
          <div class="resumo-calculo__group-title"><i class="bx bx-dollar-circle"></i> Serviço</div>
          <div class="resumo-calculo__row">
            <span>Valor do Serviço</span>
            <span class="rc-badge rc-badge--success">{{ valores.sep_valor | formatNumeroBr }}</span>
          </div>
          <div class="resumo-calculo__row">
            <span>Total de Deduções</span>
            <span class="rc-badge rc-badge--danger">{{ totalDeducoes | formatNumeroBr }}</span>
          </div>
          <div class="resumo-calculo__row">
            <span>Base de Cálculo</span>
            <span class="rc-badge rc-badge--info">{{ (valores.sep_valor - valores.sep_deducoes - valores.sep_desconto_incondicionado) | formatNumeroBr }}</span>
          </div>
          <div class="resumo-calculo__row">
            <span>Alíquota ISS</span>
            <span class="rc-badge rc-badge--info">{{ valores.sep_aliquota }}%</span>
          </div>
          <div v-if="valores.sep_iss_retido === 'S'" class="resumo-calculo__row resumo-calculo__row--sub">
            <span>ISS Retido</span>
            <span class="rc-badge rc-badge--danger-bold">{{ sepIss | formatNumeroBr }}</span>
          </div>
          <div v-else class="resumo-calculo__row resumo-calculo__row--sub">
            <span>Valor do ISS</span>
            <span class="rc-badge rc-badge--info--bold">{{ sepIss | formatNumeroBr }}</span>
          </div>

          <div class="resumo-calculo__group-title mt-2"><i class="bx bx-minus-circle"></i> Deduções</div>
          <div class="resumo-calculo__row">
            <span>Deduções</span>
            <span class="rc-badge rc-badge--danger">{{ valores.sep_deducoes | formatNumeroBr }}</span>
          </div>
          <div class="resumo-calculo__row">
            <span>Desc. Incondicionado</span>
            <span class="rc-badge rc-badge--danger">{{ valores.sep_desconto_incondicionado | formatNumeroBr }}</span>
          </div>
          <div class="resumo-calculo__row">
            <span>Desc. Condicionado</span>
            <span class="rc-badge rc-badge--danger">{{ valores.sep_desconto_condicionado | formatNumeroBr }}</span>
          </div>
        </div>

        <!-- Coluna Direita -->
        <div class="resumo-calculo__col">
          <div class="resumo-calculo__group-title"><i class="bx bx-shield-quarter"></i> Retenções Federais</div>
          <div class="resumo-calculo__row">
            <span>INSS</span>
            <span class="rc-badge rc-badge--danger">{{ valores.sep_inss | formatNumeroBr }}</span>
          </div>
          <div class="resumo-calculo__row">
            <span>IR</span>
            <span class="rc-badge rc-badge--danger">{{ valores.sep_ir | formatNumeroBr }}</span>
          </div>
          <div class="resumo-calculo__row">
            <span>PIS / COFINS / CSLL</span>
            <span class="rc-badge rc-badge--danger">{{ pisCofinsCSLL | formatNumeroBr }}</span>
          </div>
          <div class="resumo-calculo__row">
            <span>Outras</span>
            <span class="rc-badge rc-badge--danger">{{ valores.sep_outras_retencoes | formatNumeroBr }}</span>
          </div>
          <div class="resumo-calculo__row resumo-calculo__row--sub">
            <span>Total Retenções</span>
            <span class="rc-badge rc-badge--danger-bold">{{ retencaoFederal | formatNumeroBr }}</span>
          </div>

          <div class="resumo-calculo__group-title mt-2"><i class="bx bx-trending-up"></i> {{ ivaLabel }}</div>
          <div class="resumo-calculo__row">
            <span>IBS <small>({{ valores.sep_aliquota_ibs_aplicada }}%)</small></span>
            <span class="rc-badge rc-badge--warning">{{ valores.sep_valor_ibs | formatNumeroBr }}</span>
          </div>
          <div class="resumo-calculo__row">
            <span>CBS <small>({{ valores.sep_aliquota_cbs_aplicada }}%)</small></span>
            <span class="rc-badge rc-badge--warning">{{ valores.sep_valor_cbs | formatNumeroBr }}</span>
          </div>
          <div class="resumo-calculo__row resumo-calculo__row--sub">
            <span>Total IVA</span>
            <span class="rc-badge rc-badge--warning-bold">{{ ivaTotal | formatNumeroBr }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Total -->
    <div class="resumo-calculo__total">
      <span><i class="bx bx-check-double"></i> Valor Líquido</span>
      <span class="resumo-calculo__total-value">{{ valorLiquido | formatNumeroBr }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResumoCalculo",
  props: {
    valores: {type: Object, required: true},
    sepIss: {type: Number, required: true},
    retencaoFederal: {type: Number, required: true},
    valorLiquido: {type: Number, required: true},
    ivaLabel: {type: String, default: "IVA"},
  },
  computed: {
    ivaTotal() {
      return (this.valores.sep_valor_ibs || 0) + (this.valores.sep_valor_cbs || 0);
    },
    pisCofinsCSLL() {
      return (this.valores.sep_pis || 0) + (this.valores.sep_cofins || 0) + (this.valores.sep_csll || 0);
    },
    totalDeducoes() {
      return (this.valores.sep_deducoes || 0) + (this.valores.sep_desconto_incondicionado || 0) + (this.valores.sep_desconto_condicionado || 0);
    },
  },
};
</script>

<style scoped>
.resumo-calculo {
  border-radius: 8px;
  border: 1px solid rgba(85, 110, 230, 0.15);
  background: #fff;
  overflow: hidden;
}

.resumo-calculo__header {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.6rem 1rem;
  background: linear-gradient(135deg, #556ee6, #485ec4);
  color: #fff;
  font-size: 0.8125rem;
  font-weight: 600;
}
.resumo-calculo__header i { font-size: 1rem; }

.resumo-calculo__body {
  padding: 0.75rem 1rem;
}

.resumo-calculo__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 1.5rem;
}

@media (max-width: 767px) {
  .resumo-calculo__grid { grid-template-columns: 1fr; }
}

.resumo-calculo__group-title {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #74788d;
  margin-bottom: 0.25rem;
  padding-bottom: 0.2rem;
  border-bottom: 1px solid rgba(0,0,0,0.05);
}
.resumo-calculo__group-title i { font-size: 0.8125rem; color: #556ee6; }

.resumo-calculo__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.15rem 0;
  font-size: 0.78rem;
  color: #495057;
}

.resumo-calculo__row--sub {
  margin-top: 0.2rem;
  padding-top: 0.25rem;
  border-top: 1px dashed rgba(0,0,0,0.08);
  font-weight: 600;
  color: #343a40;
}

.rc-badge {
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0.1rem 0.4rem;
  border-radius: 3px;
  white-space: nowrap;
  font-family: 'Poppins', sans-serif;
}
.rc-badge--success { color: #1d8a63; background: rgba(52,195,143,.12); }
.rc-badge--danger  { color: #c0392b; background: rgba(244,106,106,.1); }
.rc-badge--danger-bold { color: #c0392b; background: rgba(244,106,106,.18); font-weight: 600; }
.rc-badge--info    { color: #2e73b8; background: rgba(80,165,241,.12); }
.rc-badge--info--bold    { color: #2e73b8; background: rgba(80,165,241,.12); font-weight: 600; }
.rc-badge--warning { color: #b87a1f; background: rgba(241,180,76,.12); }

.resumo-calculo__total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem 1rem;
  background: linear-gradient(135deg, #556ee6, #34c38f);
  color: rgba(255,255,255,.9);
  font-size: 0.8125rem;
  font-weight: 500;
}
.resumo-calculo__total i { font-size: 1rem; margin-right: 0.25rem; }
.resumo-calculo__total-value {
  font-size: 1.125rem;
  font-weight: 700;
  color: #fff;
}

.mt-2 { margin-top: 0.5rem !important; }
</style>
